import { z } from 'zod';

import { AUDIT_ACTION } from './common.js';

/**
 * RMF — HİYERARŞİ OLUŞTURMA UÇLARININ SÖZLEŞMESİ (Faz 5, HAT D).
 *
 * "RMF" = reklam yönetim fonksiyonları: kampanya, ad set ve reklamı sıfırdan
 * açmak. Okuma tarafı (`analytics`) ve yazma tarafı (`campaigns/status`,
 * `campaigns/budget`) zaten vardı; eksik olan hiyerarşiyi KURMAKTI.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 OLUŞTURULAN HER ŞEY `PAUSED` DOĞAR — bu şemalarda "aktif oluştur" ALANI YOK
 * ═══════════════════════════════════════════════════════════════════════════
 * Sözleşmenin kaynağı `connector.types.ts` → `CreateCampaignInput` başlığı.
 * Buraya bir `status` alanı eklemek, bir gün bir ajan aracının ya da bir kural
 * gövdesinin o alanı `ACTIVE` doldurması demek. Alan yoksa o hata yazılamaz.
 * Yayına alma AYRI bir çağrı (`POST /campaigns/status`) ve denetim kaydında
 * ayrı bir satır — "kim oluşturdu" ile "kim yayına aldı" iki farklı soru.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Neden üç ayrı uç, tek bir "hiyerarşi oluştur" ucu değil
 * ═══════════════════════════════════════════════════════════════════════════
 * Tek uç, kısmi başarıyı KAÇINILMAZ hâle getirirdi: kampanya oluşur, ad set
 * oluşmaz ve ortada yetim bir kampanya kalır. Üç ayrı uçta her çağrı TEK bir
 * platform mutasyonu ve sonucu tek bir yanıt; sihirbaz adımları arasında ne
 * olduğunu istemci de kullanıcı da görüyor. Geri alma kararının gerekçesi
 * `rmf.service.ts` başlığında.
 *
 * ---------------------------------------------------------------------------
 * Kimlikler BİZİM kimliklerimiz
 * ---------------------------------------------------------------------------
 * `adAccountId` / `campaignId` / `adSetId` hepsi bizim UUID'lerimiz, platform
 * kimlikleri DEĞİL. Dışarıdan platform kimliği kabul etmek kiracı
 * doğrulamasını imkânsız kılardı — `act_123/campaign_456` hangi workspace'e
 * ait, bilemezdik. Aynı karar `platform-action.service.ts`te de yazılı.
 */

// ═══════════════════════════════════════════════════════════════════════════
// Hata kodları
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Arayüz `code` üzerinden dallanıyor; `message` yalnız gösterim için.
 *
 * `IntegrationErrorCode`e eklenmediler çünkü bunların hepsi RMF akışının
 * kendi kararları — "platform bağlanamadı" sınıfından değil, "bu isteği bu
 * platformda oluşturamayız" sınıfından.
 */
export const RmfErrorCode = {
  /**
   * Adapter hiyerarşi oluşturmayı desteklemiyor (`canCreateEntities: false`).
   *
   * `PLATFORM_NOT_AVAILABLE`den ayrı: o "adapter yok" diyor, bu "adapter var
   * ama bu işi yapamıyor" diyor. Arayüz birincisinde kartı "yakında" gösterir,
   * ikincisinde "kampanya oluştur" düğmesini hiç göstermez.
   */
  PLATFORM_CANNOT_CREATE: 'PLATFORM_CANNOT_CREATE',
  /// Üst varlık (hesap/kampanya/ad set) bulunamadı ya da başka kiracıya ait.
  PARENT_NOT_FOUND: 'PARENT_NOT_FOUND',

  // ── Platformun reddi ────────────────────────────────────────────────────
  //
  // ⚠️ Bu beş kod `ConnectorError.category` kovalarının karşılığı ve
  // `platform-action.adapter.ts` içindeki `CONNECTOR_CODE` tablosuyla BİREBİR
  // aynı dizeleri kullanıyor. Orada çıplak dize olarak duruyorlar; buraya
  // taşınmalarının sebebi arayüzün tek bir sözlükten dallanabilmesi. İkisi
  // ayrışırsa aynı platform reddi iki uçta iki farklı kod döner — ana oturuma
  // "tek kaynağa indirilmeli" diye bildirildi.
  /// Jeton bozuk/iptal — kullanıcı yeniden bağlanmalı.
  PLATFORM_AUTH_FAILED: 'PLATFORM_AUTH_FAILED',
  /// Platform kotası doldu.
  RATE_LIMITED: 'RATE_LIMITED',
  /// 5xx / ağ hatası — yeniden denenebilir.
  PLATFORM_UNAVAILABLE: 'PLATFORM_UNAVAILABLE',
  /// Platform isteği reddetti (eksik alan, geçersiz değer). Yeniden denemek
  /// aynı sonucu verir.
  PLATFORM_REJECTED: 'PLATFORM_REJECTED',
  /// Sınıflandırılamayan platform hatası.
  PLATFORM_ERROR: 'PLATFORM_ERROR',

  /**
   * Gönderilen alanın bu platformda KARŞILIĞI YOK.
   *
   * `PLATFORM_REJECTED`ten ayrı ve ayrılması şart: o "platform isteği
   * reddetti, değeri düzelt" diyor, bu "bu alan burada hiç yok, kaldır"
   * diyor. Aynı kodu döndürselerdi arayüz Google kampanyasında
   * `optimizationGoal` için "geçerli bir değer seçin" derdi — geçerli değer
   * YOKKEN.
   *
   * Adapter tarafındaki üretim noktası `fieldNotSupported()`; kod oraya
   * `providerCode` olarak yazılıyor ve `platformRejection()` onu buraya
   * çeviriyor. Sözleşmede üç yerde (`rmf.ts`, `campaign-wizard.ts` ×2) bu
   * kodun adı geçiyordu ama hiçbir yerde TANIMLI DEĞİLDİ: yani belgelenmiş
   * davranış ile gerçek davranış ayrışmıştı ve ekran bu ayrımı hiç göremiyordu.
   */
  FIELD_NOT_SUPPORTED_ON_PLATFORM: 'FIELD_NOT_SUPPORTED_ON_PLATFORM',

  /**
   * Platformda varlık OLUŞTU ama yerel satır yazılamadı.
   *
   * 🔴 Bu bir hata KODU olarak var olmak zorunda: sessizce başarı dönmek,
   * kullanıcının panelde göremediği ama Google'da duran bir kampanyası olması
   * demekti. Yanıt yine 201 dönüyor (varlık gerçekten oluştu) ama
   * `localRecordWritten: false` ve bu kod `warningCode` alanında taşınıyor.
   */
  LOCAL_RECORD_NOT_WRITTEN: 'LOCAL_RECORD_NOT_WRITTEN',

  /**
   * Platform çağrısı BELİRSİZ bitti (zaman aşımı / okunamayan yanıt) ve aynı
   * `Idempotency-Key` ile tekrar denendi.
   *
   * 🔴 Bu kod olmadan tekrar denemenin sonucu İKİNCİ bir kampanya olurdu:
   * `withIdempotency` hata durumunda kilidi siliyor (doğru davranış — kalıcı
   * bir reddi 24 saat kilitlemek kullanıcıyı bloke ederdi) ama zaman aşımında
   * varlık platformda OLUŞMUŞ olabilir. `rmf.service.ts` o iki kategoriyi
   * (`transient`/`unknown`) ayrı bir işaretle saklıyor ve aynı anahtarla gelen
   * ikinci isteği ÇALIŞTIRMADAN bu kodla 409'a düşürüyor. Kullanıcının yapması
   * gereken: platformu kontrol etmek, oluşmadıysa YENİ bir anahtarla göndermek.
   */
  PLATFORM_OUTCOME_UNKNOWN: 'PLATFORM_OUTCOME_UNKNOWN',
} as const;
export type RmfErrorCode = (typeof RmfErrorCode)[keyof typeof RmfErrorCode];

// ═══════════════════════════════════════════════════════════════════════════
// Platform reddinin MAKİNE OKUNUR ayrıntısı (Faz 7b, 30 Eyl 2026)
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Platform reddinin sınıfı — `platformRejection()` gövdesinde `details.category`.
 *
 * Neden `code`un yanında ikinci bir eksen: `code` (yukarıdaki beş kod)
 * YENİDEN DENEME kararını taşıyor (auth / kota / geçici / kalıcı); ama
 * kullanıcının (ya da bir ajanın, duman testinin) yapacağı şey aynı
 * `PLATFORM_REJECTED` altında birbirinden çok farklı: "platformdan erişim
 * iste" ile "değeri düzelt" ile "bu nesne silinmiş". Bu ayrım önceden yalnız
 * mesaj METNİNDEN çıkarılabiliyordu (duman testi `permission|allowlist|…`
 * kalıbıyla) — dil ve sürüm değişince sessizce bozulan bir sözleşme.
 *
 *   ACCESS_REQUIRED       platform izin/erişim/onay istiyor: uygulama incelemesi, geliştirici
 *                         jetonu düzeyi, allowlist, eksik kapsam, hesapta rol yok. Jeton SAĞLAM.
 *   RECONNECT_REQUIRED    jeton geçersiz / süresi dolmuş / iptal — bağlantı yeniden kurulmalı.
 *   VALIDATION            istek ya da değer geçersiz — parametreyi düzelt.
 *   NOT_FOUND             hedef nesne yok, silinmiş ya da bu hesaba ait değil.
 *   UNSUPPORTED           platform bu alanı/işlemi desteklemiyor (alan karşılığı yok, arşiv
 *                         yok, yalnız sandbox, API salt okunur) — alanı kaldır / başka yol.
 *   POLICY                reklam politikası / yasal beyan reddi.
 *   RATE_LIMITED          platform kotası — `retryAfterSeconds` kadar bekle.
 *   PLATFORM_UNAVAILABLE  5xx / ağ / bakım — sonra tekrar dene.
 *   UNKNOWN               sınıflandırılamadı (bağlayıcı eşlemesi yok ya da kod tanınmıyor).
 *
 * 🔴 Liste AÇIK: yeni değer eklenebilir (geliştirici API'si "open enum"
 * kuralı). İstemci bilmediği değeri `UNKNOWN` gibi ele almalı.
 */
export const PLATFORM_REJECTION_CATEGORIES = [
  'ACCESS_REQUIRED',
  'RECONNECT_REQUIRED',
  'VALIDATION',
  'NOT_FOUND',
  'UNSUPPORTED',
  'POLICY',
  'RATE_LIMITED',
  'PLATFORM_UNAVAILABLE',
  'UNKNOWN',
] as const;
export type PlatformRejectionCategory = (typeof PLATFORM_REJECTION_CATEGORIES)[number];

/**
 * `platformRejection()` gövdesinin `details` alanı.
 *
 * `providerCode` platformun HAM hata kodu (Meta `error.code`, Google
 * `authorization_error.USER_PERMISSION_DENIED`, TikTok `40001`, X
 * `INVALID_PARAMETER`) ya da Mentorivo bağlayıcısının kendi sabit kodu
 * (`FIELD_NOT_SUPPORTED_ON_PLATFORM`, `REF_NOT_FOUND`…). Yalnız
 * `[A-Za-z0-9_.:-]` — kişisel veri ya da jeton taşıyamaz; biçime uymayan
 * kod `null` olur (mesaj metni hiçbir zaman buraya kopyalanmaz).
 */
export interface PlatformRejectionDetails {
  category: PlatformRejectionCategory;
  providerCode: string | null;
  /** Platformun alt kodu (Meta `error_subcode`); yoksa alan hiç yazılmaz. */
  providerSubcode?: string;
  /** Kota reddinde platformun söylediği bekleme; yoksa alan hiç yazılmaz. */
  retryAfterSeconds?: number;
}

// ═══════════════════════════════════════════════════════════════════════════
// Denetim kaydı — GEÇİCİ KÖPRÜ
// ═══════════════════════════════════════════════════════════════════════════

/**
 * RMF'in yazdığı denetim satırları — `AUDIT_ACTION`dan SEÇİLMİŞ üçlü.
 *
 * Bu nesne bir ikinci sözlük DEĞİL, dar bir görünüm: değerler `common.ts`teki
 * `AUDIT_ACTION`dan okunuyor, burada yeniden yazılmıyor. Yeniden yazılsaydı
 * iki dizeden biri bir gün sapar ve `/admin/audit` ekranı o satırları tanımaz
 * hâle gelirdi — denetim kaydının en sessiz bozulma biçimi.
 *
 * (Faz 5'in ilk turunda üç değer burada elle tanımlıydı ve `rmf.service.ts`
 * onları `as AuditAction` ile köprülüyordu; sözlüğe taşındıktan sonra köprü
 * de gereksizleşti.)
 */
export const RMF_AUDIT_ACTION = {
  CAMPAIGN_CREATED: AUDIT_ACTION.CAMPAIGN_CREATED,
  ADSET_CREATED: AUDIT_ACTION.ADSET_CREATED,
  AD_CREATED: AUDIT_ACTION.AD_CREATED,
} as const;
export type RmfAuditAction = (typeof RMF_AUDIT_ACTION)[keyof typeof RMF_AUDIT_ACTION];

// ═══════════════════════════════════════════════════════════════════════════
// Ortak parçalar
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Bütçe sınırları `budgetChangeSchema` ile BİREBİR aynı sayılar.
 *
 * Farklı olsalardı kullanıcı 2.000.000'luk bir kampanya oluşturabilir ama onu
 * bir daha düzenleyemezdi — düzenleme ucu 1.000.000'da reddederdi. Aynı
 * kavramın iki farklı tavanı, kullanıcının anlamlandıramayacağı bir çelişki.
 */
const dailyBudgetSchema = z.number().positive().max(1_000_000);
const lifetimeBudgetSchema = z.number().positive().max(10_000_000);

/**
 * 🔴 `platformOptions` İÇİNDE GÖNDERİLEMEYECEK ANAHTARLAR.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Neden bir denylist var — "PAUSED doğar" sözleşmesi tek alanla deliniyordu
 * ═══════════════════════════════════════════════════════════════════════════
 * Meta adapter'ı gövdeyi `{ …bizim alanlarımız, ...extraOptions(platform-
 * Options) }` diye kuruyor ve spread SONDA. Yani `platformOptions.status =
 * 'ACTIVE'` gönderen bir istemci, bu dosyanın başındaki "oluşturulan her şey
 * PAUSED doğar" kuralını tek bir alanla geçersiz kılıyor ve Meta'da O ANDA
 * harcamaya başlayan YAYINDA bir kampanya açıyordu. Yerel satır yine
 * `PAUSED` yazıldığı için panel de denetim kaydı da "duraklatılmış" diyordu:
 * yani hem para harcanıyor hem de hiçbir ekranda görünmüyordu.
 *
 * Aynı delik bütçede de açıktı: tipli `dailyBudget` alanı boş bırakılıp
 * `platformOptions.daily_budget` gönderildiğinde şemadaki tavan (1.000.000),
 * ANA→MINOR birim çevrimi ve yerel bütçe kaydı TÜMDEN atlanıyordu.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * Neden denylist, allowlist değil
 * ───────────────────────────────────────────────────────────────────────────
 * `platformOptions`un var olma sebebi, sözleşmenin bilmediği platform
 * alanlarını taşımak. Allowlist yazmak onu tipli bir alan listesine çevirir ve
 * her yeni Meta alanı için bu paketin sürümlenmesi gerekirdi. Yasaklanan şey
 * dar ve tanımlı: SÖZLEŞMENİN KENDİ ALANLARININ platform karşılıkları. Bir
 * kavramın iki girişi olmamalı; ikisi de varsa hangisinin kazandığını kimse
 * okuyamaz.
 *
 * ⚠️ Karşılaştırma normalize ediliyor (küçük harf + harf/rakam dışı atılıyor):
 * `daily_budget`, `dailyBudget` ve `DAILY-BUDGET` aynı anahtar sayılıyor.
 * Aksi hâlde yasak, yazım biçimi değiştirilerek geçilebilirdi.
 */
const RESERVED_PLATFORM_OPTION_KEYS = new Set([
  // Durum — sözleşmenin en sert kuralı.
  'status',
  'effectivestatus',
  'configuredstatus',
  // Kimlik ve ad.
  'name',
  'objective',
  'campaignid',
  'adsetid',
  'adaccountid',
  'accountid',
  // Para.
  'dailybudget',
  'lifetimebudget',
  'budgetremaining',
  // Ad set sözleşmesinin tipli alanları.
  'optimizationgoal',
  'billingevent',
  'promotedobject',
  'targeting',
  'starttime',
  'endtime',
  'specialadcategories',
  'specialadcategory',
  // Reklamın kreatif bağı.
  'creative',
  'creativeid',
  // Marka kimliği — artık `rmfAdCreativeSchema.identityRef` ile tipli alan.
  // `platformOptions` üzerinden gönderilseydi Meta adapter'ında `extraOptions`
  // onu /ads gövdesine ÜST SEVİYE parametre olarak yazardı; oysa kimlik
  // kreatifin `object_story_spec`i içinde yaşıyor. Sessizce yok sayılan bir
  // alan, kullanıcıya "sayfayı verdim" dedirtip yine devralmaya düşürürdü.
  'identityref',
  'pageid',
]);

function normalizeOptionKey(key: string): string {
  return key.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * Platforma özgü ekstralar — ADAPTER'IN İÇİNDE kalır.
 *
 * Şema burada bilerek gevşek: içeriği platform başına değişiyor ve normalize
 * etmeye çalışmak adapter sınırını üst katmana sızdırırdı. SIKI doğrulama
 * adapter'da yapılıyor (Google RSA başlık sayısı gibi) ve reddi platformun
 * değil BİZİM hata mesajımız açıklıyor.
 *
 * Gevşek ≠ serbest: sözleşmenin kendi alanlarının platform karşılıkları
 * REDDEDİLİYOR (bkz. `RESERVED_PLATFORM_OPTION_KEYS`).
 */
const platformOptionsSchema = z.record(z.string(), z.unknown()).superRefine((options, ctx) => {
  for (const key of Object.keys(options)) {
    if (!RESERVED_PLATFORM_OPTION_KEYS.has(normalizeOptionKey(key))) continue;
    ctx.addIssue({
      code: 'custom',
      path: [key],
      message: `"${key}" bu uçun kendi alanı; platformOptions içinde gönderilemez. Sözleşmedeki alanı kullanın (durum alanı YOK: oluşturulan her şey PAUSED doğar).`,
    });
  }
});

/**
 * 🔴 Google Responsive Search Ad'in ÇOKLU başlık/açıklama sözleşmesi.
 *
 * `CreateAdInput.creative` tek bir `headline` ve tek bir `bodyText` taşıyor —
 * Google en az 3 başlık ve 2 açıklama istiyor. Eksikleri aynı metni tekrar
 * ederek doldurmak (Google'ın kabul edeceği bir hile) reklamın performansını
 * düşürür ve kullanıcı bunu ASLA göremez. Bu yüzden çoklu metin
 * `platformOptions` üzerinden AÇIKÇA isteniyor; gelmezse adapter reddediyor.
 */
export const GOOGLE_RSA_OPTION_KEYS = {
  headlines: 'headlines',
  descriptions: 'descriptions',
  path1: 'path1',
  path2: 'path2',
  /// Ad group'un tıklama başı teklifi (ANA birim). Verilmezse ad group
  /// teklifsiz doğar — bkz. `google.create.ts`.
  cpcBid: 'cpcBid',
  /**
   * 🔴 POZİTİF ANAHTAR KELİMELER — ad group'un alanı, reklamın DEĞİL.
   *
   * Bu anahtar `createAdSetSchema.platformOptions` içinde gider (ad group =
   * ad set); `createAdSchema`ya konursa adapter onu görmez ve kelime SESSİZCE
   * yazılmaz. Kelimesiz bir arama ad group'u geçerli bir nesnedir ve ömrü
   * boyunca sıfır gösterim alır — yani bu alanın yanlış yere konması, hiçbir
   * hata vermeyen ve hiç çalışmayan bir kampanya üretir.
   *
   * Biçim: düz metin PHRASE, `[…]` EXACT, `+…` BROAD (`keywordsFromOptions`).
   * Sabit adı `GOOGLE_RSA_OPTION_KEYS` altında duruyor çünkü `cpcBid` de
   * burada ve o da ad group alanı — liste "Google oluşturma ekstraları",
   * yalnız RSA metinleri değil.
   */
  keywords: 'keywords',
} as const;

// ═══════════════════════════════════════════════════════════════════════════
// Kampanya
// ═══════════════════════════════════════════════════════════════════════════

export const createCampaignSchema = z
  .object({
    /// BİZİM `AdAccount.id`imiz.
    adAccountId: z.uuid(),
    name: z.string().trim().min(1).max(200),
    /**
     * Platformun kendi hedef sözcüğü (Meta `OUTCOME_TRAFFIC`, Google `SEARCH`).
     *
     * Normalize EDİLMEDİ: hedef kümesi platform başına farklı ve eşleme
     * kaybettiriyor. Okuma tarafı da (`fetchEntities` → `objective`) aynı
     * sözcük kümesini yazıyor; farklı olsalardı "oluştur → senkronla → başka
     * değer gör" döngüsü oluşurdu.
     */
    objective: z.string().trim().min(1).max(64),
    dailyBudget: dailyBudgetSchema.nullable().optional(),
    lifetimeBudget: lifetimeBudgetSchema.nullable().optional(),
    /**
     * Meta'nın `special_ad_categories`i (kredi, istihdam, konut, siyaset).
     * Yanlış bildirmek hesabın kapanmasına yol açabiliyor; boş dizi = hiçbiri.
     * Google'da doğrudan karşılığı YOK ve adapter onu kullanmıyor.
     */
    specialAdCategories: z.array(z.string().trim().min(1).max(64)).max(10).optional(),
    /**
     * Kampanyanın bitişi — TİPLİ alan, çünkü `endtime` `platformOptions`ta
     * yasaklı (bkz. `RESERVED_PLATFORM_OPTION_KEYS`).
     *
     * Google bitişi YALNIZ kampanyada tanıyor (`end_date_time`); ad group'a
     * gönderilen tarih reddediliyor. LinkedIn ömür bütçeli kampanya grubunda
     * bitişi ZORUNLU tutuyor ve eskiden onu `platformOptions.endTime`tan
     * okuyordu — o anahtar bu şemada yasak olduğu için o yol hiç
     * çalışmıyordu. Meta'da `stop_time`.
     */
    endTime: z.iso.datetime().optional(),
    platformOptions: platformOptionsSchema.optional(),
  })
  .refine(
    (v) => !(v.dailyBudget != null && v.lifetimeBudget != null),
    'Günlük ve ömür bütçesi AYNI ANDA verilemez',
  );
export type CreateCampaignRequest = z.infer<typeof createCampaignSchema>;

// ═══════════════════════════════════════════════════════════════════════════
// Ad set
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Normalize edilebilen TEK ortak hedefleme parçası: coğrafya, yaş, cinsiyet.
 *
 * İlgi alanları, özel kitleler, kelime temaları — hepsi platforma özgü kimlik
 * taşıyor ve normalize etmeye çalışmak adapter sınırını üst katmana sızdırırdı.
 * Gerisi `platformOptions` içinde adapter'ın İÇİNDE kalıyor.
 *
 * 🔴 `countries` ve `genders` TEKİLLEŞTİRİLİYOR ve tekilleştirme burada
 * yapılıyor, adapter'da değil. Gerekçe: tekrarın bedeli platform başına
 * FARKLI ve ikisi de sessiz. Google'da `['TR','tr']` aynı `mutate` paketine
 * iki özdeş `campaign_criterion` yazar → `DUPLICATE` hatası ad group'u da
 * düşürür; kampanyada zaten TR varsa uzunluk karşılaştırması "farklı ülke
 * hedeflemesi var" diyerek MEŞRU bir isteği reddeder. `['male','male']` ise
 * "iki cinsiyet de seçilmiş = hepsi" sayılıp cinsiyet hedeflemesini sessizce
 * İPTAL eder — kullanıcı "yalnız erkekler" seçtiğini sanırken reklam herkese
 * çıkar. Aynı kümeyi iki kez yazmanın hiçbir anlamı olmadığı için düzeltme
 * yeri girdinin kendisi; her adapter'a ayrı ayrı `Set` koymak, birinin
 * unutulmasını bekleyen bir kural olurdu.
 */
export const rmfTargetingSchema = z
  .object({
    /// ISO 3166-1 alfa-2. Google `geo_target_constant` istiyor; çeviri
    /// adapter'ın içinde (`google.create.ts` → `GEO_TARGET_BY_COUNTRY`).
    countries: z
      .array(z.string().trim().length(2).toUpperCase())
      .min(1)
      .max(25)
      .transform((list) => [...new Set(list)])
      .optional(),
    ageMin: z.number().int().min(13).max(65).optional(),
    ageMax: z.number().int().min(13).max(65).optional(),
    genders: z
      .array(z.enum(['male', 'female']))
      .min(1)
      .max(2)
      .transform((list) => [...new Set(list)])
      .optional(),
  })
  .refine(
    (v) => v.ageMin === undefined || v.ageMax === undefined || v.ageMin <= v.ageMax,
    'Yaş alt sınırı üst sınırdan büyük olamaz',
  );
export type RmfTargeting = z.infer<typeof rmfTargetingSchema>;

export const createAdSetSchema = z
  .object({
    /// BİZİM `Campaign.id`imiz. Hesap buradan türetiliyor — istemcinin ayrıca
    /// hesap göndermesi, iki alanın çelişme ihtimalini yaratırdı.
    campaignId: z.uuid(),
    name: z.string().trim().min(1).max(200),
    dailyBudget: dailyBudgetSchema.nullable().optional(),
    lifetimeBudget: lifetimeBudgetSchema.nullable().optional(),
    /**
     * Meta kavramları: neyin optimize edileceği ve neyin faturalanacağı.
     *
     * 🔴 İSTEĞE BAĞLI ama Meta'da ZORUNLU — servis platforma göre karar
     * veriyor. Google'da karşılıkları yok ve gönderilirlerse servis
     * `FIELD_NOT_SUPPORTED_ON_PLATFORM` ile REDDEDİYOR. Sessizce yok saymak,
     * kullanıcının seçtiği optimizasyonun uygulandığını sanması demekti.
     */
    optimizationGoal: z.string().trim().min(1).max(64).optional(),
    billingEvent: z.string().trim().min(1).max(64).optional(),
    /// Dönüşüm optimizasyonunda hedef nesne: piksel + olay (Meta).
    promotedObject: z
      .object({
        pixelId: z.string().trim().min(1).max(64).optional(),
        customEventType: z.string().trim().min(1).max(64).optional(),
        pageId: z.string().trim().min(1).max(64).optional(),
      })
      .optional(),
    targeting: rmfTargetingSchema.optional(),
    /// Varlık zaten PAUSED doğduğu için "hemen başla" harcama başlatmıyor.
    startTime: z.iso.datetime().optional(),
    endTime: z.iso.datetime().optional(),
    platformOptions: platformOptionsSchema.optional(),
  })
  .refine(
    (v) => !(v.dailyBudget != null && v.lifetimeBudget != null),
    'Günlük ve ömür bütçesi AYNI ANDA verilemez',
  );
export type CreateAdSetRequest = z.infer<typeof createAdSetSchema>;

// ═══════════════════════════════════════════════════════════════════════════
// Reklam
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Reklamın metin alanları.
 *
 * 🔴 `assetUrl` BİLEREK YOK. Sözleşme onun bizim bucket'ımızdan üretilmiş
 * KISA ÖMÜRLÜ imzalı bir adres olmasını şart koşuyor; istemciden serbest bir
 * URL kabul etmek, platformun bizim adımıza rastgele bir adresi indirmesi
 * demekti. Kütüphanedeki bir kreatifle reklam açmanın yolu
 * `POST /creative/:id/publish` — o uç imzalamayı, `Ad.creativeId` bağını ve
 * kredi muhasebesini zaten yapıyor ve ikinci bir kopyası yazılmadı.
 */
export const rmfAdCreativeSchema = z.object({
  headline: z.string().trim().min(1).max(300).optional(),
  bodyText: z.string().trim().min(1).max(2000).optional(),
  /**
   * 🔴 ZORUNLU — ve isteğe bağlı olduğu hâli bir para hatasıydı.
   *
   * Google RSA'da `final_urls` zaten zorunlu ve adapter boş gelirse
   * REDDEDİYOR. Meta tarafında ise `publishCreative` boş `linkUrl`ı
   * `https://mentorivo.com` ile DOLDURUYOR: kullanıcının müşterisine değil
   * BİZİM pazarlama sitemize giden bir reklam oluşuyor ve hedef adresin bizim
   * tarafımızdan uydurulduğu hiçbir ekranda yazmıyor — reklam yayına alındığı
   * anda ödenen her tıklama yanlış yere gidiyor.
   *
   * Varsayılanı adapter'da düzeltmek yerine alanı burada zorunlu kılmanın
   * sebebi: hedef adres bir SUNUM detayı değil, reklamın var oluş amacı.
   * Hangi platform olursa olsun onsuz bir reklam oluşturmak anlamlı değil ve
   * "verilmedi" durumunun doğru cevabı bir varsayılan değil, bir hatadır.
   */
  linkUrl: z.url().max(2000),
  ctaType: z.string().trim().min(1).max(64).optional(),
  /**
   * Reklamın yayınlandığı marka kimliği: Meta'da Sayfa kimliği, LinkedIn'de
   * organizasyon URN'i.
   *
   * 🔴 `linkUrl`in aksine ZORUNLU DEĞİL ve bu bilinçli: mevcut bir ad set'e
   * ikinci bir reklam eklerken adapter kimliği kardeş reklamdan devralıyor ve
   * kullanıcıya aynı şeyi tekrar sormak gereksiz olurdu. YENİ açılmış bir ad
   * set'in ilk reklamında devralınacak bir şey yoktur; orada verilmezse
   * adapter neyi istediğini söyleyen bir hata döndürür — sessizce yanlış bir
   * sayfa seçmez.
   *
   * Zorunlu KILINAMAZ çünkü kimliği listelemenin bir yolu yok: Meta'da sayfa
   * listesi `pages_show_list` izni istiyor ve o izin OAuth kapsamlarımızda
   * yok. Zorunlu olsaydı, devralmanın çalıştığı durumda bile kullanıcıdan
   * bulamayacağı bir numara istemiş olurduk.
   */
  identityRef: z.string().trim().min(1).max(128).optional(),
});
export type RmfAdCreative = z.infer<typeof rmfAdCreativeSchema>;

export const createAdSchema = z
  .object({
    /// BİZİM `AdSet.id`imiz.
    adSetId: z.uuid(),
    name: z.string().trim().min(1).max(200),
    /// Platformda ZATEN duran bir kreatifin kimliği (Meta). Google'da kreatif
    /// bağımsız bir nesne değil; adapter bu alanı reddediyor.
    existingCreativeRef: z.string().trim().min(1).max(200).optional(),
    creative: rmfAdCreativeSchema.optional(),
    platformOptions: platformOptionsSchema.optional(),
  })
  .refine(
    (v) => (v.existingCreativeRef !== undefined) !== (v.creative !== undefined),
    'Mevcut kreatif kimliği ya da yeni kreatif alanlarından TAM BİRİ verilmeli',
  );
export type CreateAdRequest = z.infer<typeof createAdSchema>;

// ═══════════════════════════════════════════════════════════════════════════
// Yanıt
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Oluşturmanın sonucu.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 `localRecordWritten` neden yanıtta duruyor
 * ═══════════════════════════════════════════════════════════════════════════
 * İki ayrı sistem var: platform ve bizim veritabanımız. Platform çağrısı
 * başarılı olup yerel yazma başarısız olabilir (DB düşmesi, kilit). O anda
 * "başarılı" demek yalan olmaz — varlık GERÇEKTEN oluştu — ama eksik olur:
 * kullanıcı panelde onu göremez ve ikinci kez oluşturmayı dener.
 *
 * Bu yüzden yanıt iki gerçeği AYRI taşıyor. `false` olduğunda `id` de `null`
 * olur ve `warningCode` `LOCAL_RECORD_NOT_WRITTEN` gelir; bir sonraki senkron
 * satırı zaten `platformRef` üzerinden upsert edecek.
 */
export interface RmfCreateResult {
  level: 'CAMPAIGN' | 'ADSET' | 'AD';
  /// BİZİM kimliğimiz. Yerel satır yazılamadıysa `null`.
  id: string | null;
  platformRef: string;
  /// Platformun KABUL ETTİĞİ ad — bizim yazdığımız değil. Platformlar adı
  /// kırpabiliyor; bizimkini saklarsak ilk senkronda ad "değişmiş" görünür.
  name: string;
  /// 🔴 Her zaman `PAUSED`. Tip de sabit: başka bir değer dönmesi mümkün olsa
  /// arayüz "yayında" rozeti basabilirdi.
  status: 'PAUSED';
  previewUrl: string | null;
  localRecordWritten: boolean;
  warningCode: RmfErrorCode | null;
}
